/* @ngInject */
const settingFields = (

) => {
  const self = {}

  return self
}
export default settingFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/resources/fields.resource.js